import Announcements from './Announcements.js';
import OldSearch from '../../components/OldSearch.jsx';
import KnowQuestHomeLogo from '../../assets/images/logo.png';
import './home.css';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Modern Announcement Banner - Properly Aligned */}
      <div className="w-full pt-16 pb-6">
        <Announcements />
      </div>

      {/* Hero Section - Modern, Clean Layout */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 py-8 max-w-6xl mx-auto">
        {/* Logo Section - Cleaner spacing */}
        <div className="mb-8 animate-float">
          <img
            src={KnowQuestHomeLogo}
            alt="KnowQuest"
            className="w-24 h-24 md:w-32 md:h-32 transition-all duration-500 hover:scale-110 drop-shadow-2xl"
          />
        </div>

        {/* Main Heading - Modern Typography */}
        <div className="text-center mb-6 space-y-6 animate-fade-in-up">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight">
            <span className="gradient-text">Trusted</span>
            <span className="text-white"> Reviews</span>
            <br />
            <span className="text-white/80">Made Simple</span>
          </h1>

          <p className="text-lg md:text-xl text-faded/90 font-light max-w-2xl mx-auto leading-relaxed">
            Discover authentic reviews and ratings across entertainment, games,
            and more
          </p>
        </div>

        {/* Search Section - Enhanced Modern Design */}
        <div
          className="w-full max-w-2xl mb-8 animate-fade-in-up"
          style={{ animationDelay: '0.3s' }}
        >
          <OldSearch />
        </div>

        {/* Call to Action - Subtle but Present */}
        <div className="text-center">
          <p className="text-faded/70 text-sm md:text-base">
            Start exploring trusted reviews from our community
          </p>
          <div className="mt-4">
            <a
              href="/advance-search/all"
              className="inline-flex items-center px-6 py-3 bg-secondary hover:bg-secondary/90 text-primary font-semibold rounded-lg transition-all duration-200 hover:scale-105 shadow-lg"
            >
              Browse Advanced Search
              <svg
                className="ml-2 w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </div>
        </div>

        {/* About Section - Better Layout */}
        {/*
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
            <div className="text-center mb-4">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
                Why KnowQuest?
              </h2>
              <div className="w-16 h-1 bg-gradient-to-r from-secondary to-orange-400 mx-auto rounded-full"></div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 text-white/90">
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-secondary rounded-full flex items-center justify-center mt-1 flex-shrink-0">
                    <svg className="w-3 h-3 text-primary" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p>
                    <strong className="text-secondary">Credible & Trustworthy:</strong> Verified customers provide authentic feedback with protected anonymity
                  </p>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-secondary rounded-full flex items-center justify-center mt-1 flex-shrink-0">
                    <svg className="w-3 h-3 text-primary" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p>
                    <strong className="text-secondary">Privacy First:</strong> No personal information collected - just honest, representative feedback
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-secondary rounded-full flex items-center justify-center mt-1 flex-shrink-0">
                    <svg className="w-3 h-3 text-primary" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p>
                    <strong className="text-secondary">Comprehensive Coverage:</strong> Standardized insights across entertainment, dining, finance, gaming & education
                  </p>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-secondary rounded-full flex items-center justify-center mt-1 flex-shrink-0">
                    <svg className="w-3 h-3 text-primary" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p>
                    <strong className="text-secondary">Actionable Data:</strong> Beyond generic ratings to provide meaningful insights for better decisions
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center mt-8">
              <p className="text-white/70 text-lg italic">
                Discover a smarter way to connect, improve, and grow with KnowQuest
              </p>
            </div>
          </div>
        </div>
        */}
      </div>

      {/* Bottom Gradient Fade */}
      <div className="h-24 bg-gradient-to-t from-primary/50 to-transparent"></div>
    </div>
  );
}
